import { EngagementOracle } from "@airdao/bond-periphery/core/contracts/types";
import { ContractNames, Contracts } from "@airdao/bond-periphery/core";
import { AddressLike } from "ethers";

export async function GetUserTier(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementOracle, user: AddressLike): Promise<bigint> {
  const oracle = contracts.getContractByName(contractName) as unknown as EngagementOracle;
  return await oracle.getUserTier(user);
}

export const GetterMethods = {
  GetUserTier,
};

export default GetterMethods;